import dayjs, {Dayjs} from "dayjs";

export const plural = (n: number, titles: string[]) => {
  const abs = Math.abs(n)
  return `${n} ` + titles[abs % 10 === 1 && abs % 100 != 11 ? 0 : abs % 10 >= 2 && abs % 10 <= 4 && (abs % 100 < 10 || abs % 100 >= 20) ? 1 : 2];
}

export const parseJwt = function (token: string) {
  if (!token) {
    return ''
  }
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))

  return JSON.parse(jsonPayload)
}

export const isEqualValues = (firstValue: any, secondValue: any) => {
  if (typeof firstValue !== typeof secondValue) {
    return false
  }

  if (Array.isArray(firstValue) && Array.isArray(secondValue)) {
    if (firstValue.length !== secondValue.length) {
      return false
    }

    for (let key in firstValue) {
      const firstItem = firstValue[key]
      const secondItem = secondValue[key]

      if (firstItem instanceof dayjs && !(secondItem instanceof dayjs) || !(firstItem instanceof dayjs) && secondItem instanceof dayjs) {
        return false
      } else if (firstItem instanceof dayjs && secondItem instanceof dayjs) {
        if (!dayjs(firstItem as Dayjs).isSame(dayjs(secondItem as Dayjs))) {
          return false
        }

        continue
      }

      if (typeof firstItem === 'object' && typeof secondItem === 'object') {
        if (!firstItem && secondItem || firstItem && !secondItem) {
          return false
        }

        return firstItem && secondItem && firstItem.value === secondItem.value
      } else {
        if (firstValue !== secondValue) {
          return false
        }
      }
    }
  }

  if (typeof firstValue === 'object' && typeof secondValue === 'object') {
    if (firstValue && !secondValue || !firstValue && secondValue) {
      return false
    }

    return firstValue && secondValue && firstValue.value === secondValue.value
  }

  return firstValue === secondValue
}
